export default __webpack_public_path__ + "static/media/profile3.fd650869.jpg";